import { UserState } from "@gx1/gx-npm-lib";

const identifyFS = async (event: { channel: string, payload: UserState | undefined }) => {
  const userState = event.payload;
  if (!(userState && userState.hasUserState)) {
    return;
  }
  const { acquisitionSource, email, hashedUserId } = userState;
  if (!email || ["@gartner.com", "@alphabet.com", "@yopmail.com", "@gmail.com", "@wearehackerone.com", "@bugcrowdninja.com"].some((x) => email.endsWith(x))) {
    return;
  }
  const companyDomain = email.split("@")[1];
  window.FS("start");
  window.FS("setIdentity", {
    uid: hashedUserId,
    properties: {
      displayName: `${hashedUserId}@${companyDomain}`,
      userAccess: true,
      userAcquisitionSource: acquisitionSource,
    }
  });
};

const shutdownFS = async () => {
  if (window.FS) {
    window.FS("shutdown");
  }
};

export const initializeFS = async () => {
  await window.eventBus.subscribe("USER_STATE", true, identifyFS);
  await window.eventBus.subscribe("USER_LOGGED_OUT", shutdownFS);
};
